(function () {
  'use strict';

  var BUILD_VERSION = '2026-09-23.2';

  if (window.__samiInventoryLimitLoaded) return;
  window.__samiInventoryLimitLoaded = true;
  window.__samiInventoryLimitVersion = BUILD_VERSION;

  var config = Object.assign({
    quoteQuantitySelector: '.grfq-product-item .item_qty',
    quoteRowSelector: '.grfq-product-item',
    quotePlusSelector: '.grfq-item-quantity-plus',
    quoteSubmitSelector: '#grfq-form #submitRFQForm',
    productFormSelector: 'form[action*="/cart/add"]',
    productQuantitySelector: 'input[name="quantity"]',
    productVariantSelector: '[name="id"]',
    productPlusSelector: 'quantity-input button[name="plus"], .quantity__button[name="plus"]',
    productQuoteButtonSelector: '.rfq-btn, [onclick*="GRFQApp.addProduct"]',
    selectedProductVariantId: null,
    inventoryView: 'sami-inventory',
    cacheMilliseconds: 60000,
    messages: {}
  }, window.SamiInventoryLimitConfig || {});

  config.messages = Object.assign({
    limit: 'Only {{ quantity }} item(s) are currently available.',
    checking: 'Checking current availability…',
    unavailable: 'This item is currently out of stock.',
    verifyError: 'We could not verify current inventory. Please try again.'
  }, config.messages || {});

  var productCache = new Map();
  var pendingRequests = new Map();
  var observerTimer = null;

  function toInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalizedQuantity(input) {
    return Math.max(0, toInteger(input && input.value, 0));
  }

  function inventoryRule(variant) {
    if (!variant) return null;

    var tracked = variant.inventory_management !== null &&
      variant.inventory_management !== '' &&
      typeof variant.inventory_management !== 'undefined';
    var continueSelling = String(variant.inventory_policy || '').toLowerCase() === 'continue';

    return {
      limited: tracked && !continueSelling,
      quantity: Math.max(0, toInteger(variant.inventory_quantity, 0)),
      variantId: String(variant.id)
    };
  }

  function messageElement(input) {
    if (!input) return null;
    var id = input.dataset.samiInventoryMessageId;
    var message = id ? document.getElementById(id) : null;
    if (message) return message;

    message = document.createElement('span');
    message.className = 'sami-inventory-limit-message';
    message.id = 'sami-inventory-limit-' + Math.random().toString(36).slice(2);
    message.hidden = true;
    message.setAttribute('role', 'alert');
    input.dataset.samiInventoryMessageId = message.id;

    var wrapper = input.closest('.grfq-input-group, .quantity, .product-form__quantity');
    (wrapper || input).insertAdjacentElement('afterend', message);
    return message;
  }

  function showMessage(input, text) {
    var message = messageElement(input);
    if (!message) return;
    if (message.textContent !== text) message.textContent = text;
    message.hidden = false;
    input.setAttribute('aria-describedby', message.id);
    input.setAttribute('aria-invalid', 'true');
  }

  function clearMessage(input) {
    if (!input) return;
    var id = input.dataset.samiInventoryMessageId;
    var message = id ? document.getElementById(id) : null;
    if (message) {
      if (message.textContent) message.textContent = '';
      message.hidden = true;
    }
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
  }

  function limitMessage(quantity) {
    if (quantity <= 0) return config.messages.unavailable;
    return config.messages.limit
      .replace('{{ quantity }}', String(quantity))
      .replace('__quantity__', String(quantity));
  }

  function setPlusState(input, disabled) {
    var row = input && input.closest(config.quoteRowSelector);
    var plus = row && row.querySelector(config.quotePlusSelector);
    if (!plus) return;

    plus.classList.toggle('sami-inventory-limit-disabled', disabled);
    plus.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function rootPath() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  function productHandleFromUrl(value) {
    if (!value) return null;
    try {
      var parsed = new URL(value, window.location.origin);
      var match = parsed.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (error) {
      return null;
    }
  }

  async function fetchInventory(handle, forceRefresh) {
    if (!handle) throw new Error('Missing product handle');

    var cached = productCache.get(handle);
    var now = Date.now();
    if (!forceRefresh && cached && now - cached.timestamp < config.cacheMilliseconds) {
      return cached.data;
    }
    if (pendingRequests.has(handle)) return pendingRequests.get(handle);

    var root = rootPath();
    var separator = root.endsWith('/') ? '' : '/';
    var url = root + separator + 'products/' + encodeURIComponent(handle) +
      '?view=' + encodeURIComponent(config.inventoryView) +
      (forceRefresh ? '&_=' + now : '');

    var request = fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Inventory endpoint returned ' + response.status);
      return response.json();
    }).then(function (data) {
      if (!data || !Array.isArray(data.variants)) throw new Error('Invalid inventory response');
      productCache.set(handle, { timestamp: Date.now(), data: data });
      return data;
    }).finally(function () {
      pendingRequests.delete(handle);
    });

    pendingRequests.set(handle, request);
    return request;
  }

  function quoteItemForInput(input) {
    var row = input && input.closest(config.quoteRowSelector);
    if (!row || !window.GRFQApp) return null;

    var groupId = row.getAttribute('data-group-id');
    var itemKey = toInteger(row.getAttribute('data-key'), -1);
    var rowId = row.getAttribute('id');

    if (groupId !== null && window.GRFQApp.productGroup && Array.isArray(window.GRFQApp.productGroup.groups)) {
      var group = window.GRFQApp.productGroup.groups[toInteger(groupId, -1)];
      if (group && Array.isArray(group.items)) {
        if (itemKey >= 0 && group.items[itemKey]) return group.items[itemKey];
        return group.items.find(function (item) {
          return String(item.quoteId) === String(rowId);
        }) || null;
      }
    }

    var items = Array.isArray(window.GRFQApp.quoteItems) ? window.GRFQApp.quoteItems : [];
    if (itemKey >= 0 && items[itemKey]) return items[itemKey];
    return items.find(function (item) {
      return String(item.quoteId) === String(rowId);
    }) || null;
  }

  function quoteItemIdentity(input) {
    var row = input && input.closest(config.quoteRowSelector);
    var item = quoteItemForInput(input) || {};
    var link = row && row.querySelector('a[href*="/products/"]');
    var productUrl = item.product_url || (link && link.getAttribute('href')) || '';
    var variantId = item.variant_id || item.variantId;

    if (!variantId) {
      try {
        variantId = new URL(productUrl, window.location.origin).searchParams.get('variant');
      } catch (error) {
        variantId = null;
      }
    }

    return {
      handle: productHandleFromUrl(productUrl),
      variantId: variantId ? String(variantId) : null
    };
  }

  function quoteInputsForVariant(variantId) {
    return Array.from(document.querySelectorAll(config.quoteQuantitySelector)).filter(function (input) {
      return input.dataset.samiVariantId === String(variantId) &&
        input.dataset.samiInventoryLimited === 'true';
    });
  }

  function updateVariantLimits(variantId) {
    var inputs = quoteInputsForVariant(variantId);
    if (!inputs.length) return;

    var inventory = Math.max(0, toInteger(inputs[0].dataset.samiInventoryQuantity, 0));
    inputs.forEach(function (input) {
      var usedByOtherRows = inputs.reduce(function (sum, other) {
        return sum + (other === input ? 0 : normalizedQuantity(other));
      }, 0);
      var maximumForThisRow = Math.max(0, inventory - usedByOtherRows);
      input.max = String(maximumForThisRow);
      input.dataset.samiCurrentMaximum = String(maximumForThisRow);

      var invalid = normalizedQuantity(input) > maximumForThisRow;
      setPlusState(input, invalid || normalizedQuantity(input) >= maximumForThisRow);
      if (invalid) showMessage(input, limitMessage(maximumForThisRow));
      else clearMessage(input);
    });
  }

  function clearInventoryRule(input) {
    input.removeAttribute('max');
    delete input.dataset.samiVariantId;
    delete input.dataset.samiInventoryQuantity;
    delete input.dataset.samiCurrentMaximum;
    input.dataset.samiInventoryLimited = 'false';
    setPlusState(input, false);
    clearMessage(input);
  }

  function applyQuoteRule(input, rule) {
    if (!rule || !rule.limited) {
      clearInventoryRule(input);
      return;
    }

    input.dataset.samiVariantId = rule.variantId;
    input.dataset.samiInventoryQuantity = String(rule.quantity);
    input.dataset.samiInventoryLimited = 'true';
    updateVariantLimits(rule.variantId);
  }

  async function hydrateQuoteInput(input, forceRefresh) {
    if (!input || !input.isConnected) return { ignored: true };
    var identity = quoteItemIdentity(input);
    if (!identity.handle || !identity.variantId) {
      clearInventoryRule(input);
      return { ignored: true };
    }

    try {
      var product = await fetchInventory(identity.handle, forceRefresh);
      var variant = product.variants.find(function (entry) {
        return String(entry.id) === identity.variantId;
      });
      if (!variant) throw new Error('Variant not found in inventory response');
      delete input.dataset.samiInventoryVerifyFailed;
      applyQuoteRule(input, inventoryRule(variant));
      return { ignored: false, verified: true };
    } catch (error) {
      input.dataset.samiInventoryVerifyFailed = 'true';
      if (forceRefresh) showMessage(input, config.messages.verifyError);
      return { ignored: false, verified: false, error: error };
    }
  }

  function hydrateQuoteInputs(forceRefresh) {
    var inputs = Array.from(document.querySelectorAll(config.quoteQuantitySelector));
    return Promise.all(inputs.map(function (input) {
      return hydrateQuoteInput(input, forceRefresh);
    })).then(function (results) {
      var variantIds = new Set(inputs.map(function (input) {
        return input.dataset.samiVariantId;
      }).filter(Boolean));
      variantIds.forEach(updateVariantLimits);
      return { inputs: inputs, results: results };
    });
  }

  function validateQuoteTotals(inputs) {
    var grouped = new Map();
    inputs.forEach(function (input) {
      if (input.dataset.samiInventoryLimited !== 'true') return;
      var id = input.dataset.samiVariantId;
      if (!grouped.has(id)) grouped.set(id, []);
      grouped.get(id).push(input);
    });

    var firstInvalid = null;
    grouped.forEach(function (variantInputs) {
      var inventory = Math.max(0, toInteger(variantInputs[0].dataset.samiInventoryQuantity, 0));
      var requested = variantInputs.reduce(function (sum, input) {
        return sum + normalizedQuantity(input);
      }, 0);
      var invalid = requested > inventory;

      variantInputs.forEach(function (input) {
        if (invalid) {
          showMessage(input, limitMessage(inventory));
          if (!firstInvalid) firstInvalid = input;
        }
      });
    });

    if (firstInvalid) {
      firstInvalid.focus();
      return false;
    }
    return true;
  }

  function enforceInputMaximum(input) {
    if (!input || input.dataset.samiInventoryLimited !== 'true') return true;
    var maximum = Math.max(0, toInteger(input.dataset.samiCurrentMaximum, 0));
    if (normalizedQuantity(input) <= maximum) return true;

    input.value = String(maximum);
    showMessage(input, limitMessage(maximum));
    setPlusState(input, true);
    return false;
  }

  function localProductVariants() {
    return Array.isArray(config.productVariants) ? config.productVariants : [];
  }

  function associatedFormControl(form, selector, name) {
    if (!form) return null;

    var directControl = form.querySelector(selector);
    if (directControl) return directControl;

    // Horizon and some other Shopify themes render the quantity component
    // outside the product form and associate it through the `form` attribute.
    if (form.elements && name) {
      var namedControl = form.elements.namedItem(name);
      if (namedControl && namedControl.nodeType === 1) return namedControl;
      if (namedControl && namedControl.length) {
        for (var index = 0; index < namedControl.length; index += 1) {
          if (namedControl[index].matches(selector)) return namedControl[index];
        }
      }
    }

    var formId = form.getAttribute('id');
    if (!formId) return null;
    return Array.from(document.querySelectorAll(selector)).find(function (control) {
      return control.getAttribute('form') === formId;
    }) || null;
  }

  function productFormForQuantity(input) {
    if (!input || !input.matches(config.productQuantitySelector)) return null;
    var form = input.form;
    return form && form.matches(config.productFormSelector) ? form : null;
  }

  function selectedVariantId(form) {
    var variantInput = associatedFormControl(form, config.productVariantSelector, 'id');
    if (variantInput && variantInput.value) return String(variantInput.value);
    var urlVariantId = new URL(window.location.href).searchParams.get('variant');
    if (urlVariantId) return urlVariantId;
    if (config.selectedProductVariantId) return String(config.selectedProductVariantId);
    if (localProductVariants().length === 1) return String(localProductVariants()[0].id);
    return null;
  }

  function applyProductFormRule(form, explicitVariantId) {
    if (!form) return;
    var input = associatedFormControl(form, config.productQuantitySelector, 'quantity');
    if (!input) return;

    var variantId = explicitVariantId || selectedVariantId(form);
    var variant = localProductVariants().find(function (entry) {
      return String(entry.id) === String(variantId);
    });
    var rule = inventoryRule(variant);

    if (!rule || !rule.limited) {
      input.removeAttribute('max');
      delete input.dataset.samiCurrentMaximum;
      input.dataset.samiInventoryLimited = 'false';
      clearMessage(input);
      return;
    }

    input.max = String(rule.quantity);
    input.dataset.samiCurrentMaximum = String(rule.quantity);
    input.dataset.samiInventoryLimited = 'true';
    var invalid = normalizedQuantity(input) > rule.quantity;
    var quantityComponent = input.closest('quantity-input, .quantity');
    var plus = quantityComponent && quantityComponent.querySelector(config.productPlusSelector);
    if (plus) {
      var plusDisabled = invalid || normalizedQuantity(input) >= rule.quantity;
      plus.classList.toggle('sami-inventory-limit-disabled', plusDisabled);
      plus.setAttribute('aria-disabled', plusDisabled ? 'true' : 'false');
    }
    if (invalid) showMessage(input, limitMessage(rule.quantity));
    else clearMessage(input);
  }

  function applyAllProductForms(explicitVariantId) {
    document.querySelectorAll(config.productFormSelector).forEach(function (form) {
      applyProductFormRule(form, explicitVariantId);
    });
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest(config.quoteQuantitySelector);
    if (!input && productFormForQuantity(event.target)) input = event.target;
    if (!input) return;
    enforceInputMaximum(input);
    if (input.dataset.samiVariantId) updateVariantLimits(input.dataset.samiVariantId);
    if (productFormForQuantity(input)) applyProductFormRule(productFormForQuantity(input));
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches(config.productVariantSelector)) {
      applyAllProductForms(String(event.target.value));
      return;
    }

    var input = event.target.closest && event.target.closest(config.quoteQuantitySelector);
    if (!input && productFormForQuantity(event.target)) input = event.target;
    if (!input) return;
    enforceInputMaximum(input);
    if (input.dataset.samiVariantId) {
      setTimeout(function () { updateVariantLimits(input.dataset.samiVariantId); }, 0);
    }
    if (productFormForQuantity(input)) applyProductFormRule(productFormForQuantity(input));
  }, true);

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && (event.detail.variant || event.detail);
    if (variant && variant.id) applyAllProductForms(String(variant.id));
  });

  document.addEventListener('click', function (event) {
    var productPlus = event.target.closest && event.target.closest(config.productPlusSelector);
    if (productPlus) {
      var productQuantity = productPlus.closest('quantity-input, .quantity') &&
        productPlus.closest('quantity-input, .quantity').querySelector(config.productQuantitySelector);
      if (productQuantity && productFormForQuantity(productQuantity) &&
          productQuantity.dataset.samiInventoryLimited === 'true' &&
          normalizedQuantity(productQuantity) >= toInteger(productQuantity.dataset.samiCurrentMaximum, 0)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showMessage(productQuantity, limitMessage(toInteger(productQuantity.dataset.samiCurrentMaximum, 0)));
        return;
      }
    }

    var productQuoteButton = event.target.closest && event.target.closest(config.productQuoteButtonSelector);
    if (productQuoteButton) {
      var quoteProductForm = productQuoteButton.closest(config.productFormSelector);
      var quoteProductQuantity = associatedFormControl(quoteProductForm, config.productQuantitySelector, 'quantity');
      if (quoteProductQuantity && quoteProductQuantity.dataset.samiInventoryLimited === 'true') {
        var maximum = toInteger(quoteProductQuantity.dataset.samiCurrentMaximum, 0);
        if (maximum <= 0 || normalizedQuantity(quoteProductQuantity) > maximum) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showMessage(quoteProductQuantity, limitMessage(maximum));
          quoteProductQuantity.focus();
          return;
        }
      }
    }

    var plus = event.target.closest && event.target.closest(config.quotePlusSelector);
    if (!plus) return;
    var row = plus.closest(config.quoteRowSelector);
    var input = row && row.querySelector(config.quoteQuantitySelector);
    if (!input) return;

    if (!input.dataset.samiInventoryLimited) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage(input, config.messages.checking);
      hydrateQuoteInput(input, false).then(function () {
        if (input.dataset.samiInventoryVerifyFailed === 'true') {
          showMessage(input, config.messages.verifyError);
          return;
        }
        if (input.dataset.samiInventoryLimited !== 'true' ||
            normalizedQuantity(input) < toInteger(input.dataset.samiCurrentMaximum, 0)) {
          plus.click();
        }
      });
      return;
    }

    if (input.dataset.samiInventoryLimited === 'true' &&
        normalizedQuantity(input) >= toInteger(input.dataset.samiCurrentMaximum, 0)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage(input, limitMessage(toInteger(input.dataset.samiCurrentMaximum, 0)));
    }
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(config.quoteSubmitSelector);
    if (!button) return;

    if (button.dataset.samiInventorySubmitVerified === 'true') {
      delete button.dataset.samiInventorySubmitVerified;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var wasDisabled = button.disabled;
    button.disabled = true;
    hydrateQuoteInputs(true).then(function (state) {
      var failedVerification = state.results.some(function (result) {
        return !result.ignored && result.verified === false;
      });
      var valid = !failedVerification && validateQuoteTotals(state.inputs);
      button.disabled = wasDisabled;

      if (valid) {
        button.dataset.samiInventorySubmitVerified = 'true';
        button.click();
      }
    });
  }, true);

  function initialize() {
    applyAllProductForms();
    hydrateQuoteInputs(false);

    var observer = new MutationObserver(function () {
      clearTimeout(observerTimer);
      observerTimer = setTimeout(function () {
        applyAllProductForms();
        hydrateQuoteInputs(false);
      }, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
